var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { "vue-bulma-tabs": true, [`is-layout-${_vm.layout}`]: true } },
    [
      _c(
        "div",
        {
          class: {
            tabs: true,
            [`is-${_vm.size}`]: _vm.size,
            [`is-${_vm.alignment}`]: _vm.alignment,
            [`is-${_vm.type}`]: _vm.type,
            "is-fullwidth": _vm.isFullwidth,
          },
        },
        [
          _vm._t("left-tab-list"),
          _c(
            "tab-list",
            _vm._l(_vm.tabPanes, function (tab, index) {
              return _c(
                "li",
                {
                  key: index,
                  class: {
                    "is-active": _vm.isActived(index),
                    "is-disabled": tab.disabled,
                    "is-flex": true,
                  },
                  attrs: {
                    role: "tab",
                    "aria-selected": _vm.isActived(index) ? "true" : "false",
                    "aria-expanded": _vm.isActived(index) ? "true" : "false",
                    "aria-disabled": tab.disabled ? "true" : "false",
                    selected: _vm.isActived(index),
                    disabled: tab.disabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.select(index)
                    },
                  },
                },
                [
                  _c("a", { staticClass: "is-unselectable" }, [
                    tab.icon
                      ? _c(
                          "span",
                          {
                            class: [
                              "icon",
                              { "is-small": _vm.size !== "large" },
                            ],
                          },
                          [_c("i", { class: tab.icon })]
                        )
                      : _vm._e(),
                    _c("span", [_vm._v(_vm._s(tab.label))]),
                  ]),
                ]
              )
            }),
            0
          ),
          _vm._t("right-tab-list"),
        ],
        2
      ),
      _c("div", { staticClass: "tab-content is-flex" }, [_vm._t("default")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }